var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import { css } from 'styled-components';
import { themeOrTokens } from '../utils';
export var focus = function (_a) {
    var outline = _a.outline, noPseudo = _a.noPseudo, tokensOrTheme = __rest(_a, ["outline", "noPseudo"]);
    var style = !!outline
        ? outline
        : themeOrTokens(tokensOrTheme).outlines.basic;
    return !!noPseudo
        ? style
        : css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        &:focus {\n          ", "\n        }\n      "], ["\n        &:focus {\n          ", "\n        }\n      "])), style);
};
var templateObject_1;
//# sourceMappingURL=focus.js.map